import { useState } from 'react';

import { useSessionStore } from '@/entities/session';
import { toPlayerMessage } from '@/shared/api';
import { Button } from '@/shared/ui';

import styles from './DisplayNameForm.module.scss';

const MIN_LENGTH = 2;
const MAX_LENGTH = 32;

/** Ник в лидерборде: `PATCH /users/me/display-name`. Границы — как в DTO. */
export function DisplayNameForm() {
  const currentName = useSessionStore((state) => state.user?.displayName ?? '');
  const changeDisplayName = useSessionStore((state) => state.changeDisplayName);

  const [value, setValue] = useState(currentName);
  const [isSaving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isSaved, setSaved] = useState(false);

  const isValid =
    value.trim().length >= MIN_LENGTH && value.trim().length <= MAX_LENGTH;

  const handleSubmit = async (): Promise<void> => {
    setSaving(true);
    setError(null);
    setSaved(false);
    try {
      await changeDisplayName(value.trim());
      setSaved(true);
    } catch (cause) {
      setError(toPlayerMessage(cause));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form
      className={styles.form}
      onSubmit={(event) => {
        event.preventDefault();
        void handleSubmit();
      }}
    >
      <label className={styles.label} htmlFor="display-name">
        Ник в лидерборде
      </label>
      <input
        id="display-name"
        className={styles.input}
        value={value}
        maxLength={MAX_LENGTH}
        data-testid="display-name-input"
        onChange={(event) => {
          setValue(event.target.value);
          setSaved(false);
        }}
      />

      {error ? (
        <p className={styles.error} role="alert">
          {error}
        </p>
      ) : null}
      {isSaved ? <p className={styles.ok}>Сохранено</p> : null}

      <Button
        type="submit"
        variant="secondary"
        loading={isSaving}
        disabled={!isValid || value.trim() === currentName}
      >
        Сохранить
      </Button>
    </form>
  );
}
